// © Microsoft Corporation. All rights reserved.

/** name of property that indicates whether we've successfully determined if the user has an MSA or not */
export const hasMsaPropertyName = "HasMsa";

/** name of cookie used to send the WAM-sourced login token to server */
export const loginTokenCookieName = "at";

/** name of auth token cookie dropped by the browser */
export const browserAuthTokenCookieName = "lt";

/** key name of storage item used to prevent infinite refresh */
export const signingInActiveKey = "sign-in-active";

/** key name of storage item used to prevent infinite refresh in conjunction with above */
export const signingInPendingKey = "sign-in-pending";

/** key name of storage item used to indicate to telemetry that the page was refreshed due to sign-in activity */
export const signingInRefreshedPageKey = "sign-in-refreshed-page";

/** key used to store the account ID (when supported) */
export const msaAuthAccountKey = "esMsaAuthAccountKey";

/** The default OCID to be used in OneService calls */
export const defaultOneServiceOcid = "Peregrine";
